// extracted by mini-css-extract-plugin
module.exports = {"box":"box--2RaSX","item":"item--2Bis4","title":"title--2NYCy"};